const tagsCommandePublique = [
  'entreprise-publique'
];

const codeActiviteJuridiqueCommandePublique = [
  "4110", "4120", "4130", "4140", "4150", "4160", "5546", "5547", "5646", "5647", "7111", "7112", "7113", "7120", "7150", "7160", "7171", "7172", "7179", "7190", "7210", "7220", "7225", "7229", "7230", "7312", "7313", "7331", "7340", "7343", "7344", "7345", "7346", "7347", "7348", "7349", "7351", "7352", "7353", "7354", "7355", "7356", "7357", "7361", "7362", "7366", "7367", "7371", "7372", "7373", "7379", "7382", "7383", "7384", "7385", "7389", "7410", "7430", "7450", "7470", "7490", "8110", "8120"
];

const tagsPotentiellementCommandePublique = [
  'services-publics-potentiels'
];

const codeActiviteJuridiquePotentiellementCommandePublique = [
  "5410", "5415", "5430", "5510", "5515", "5530", "5610", "5615", "5630", "5670", "7363", "7364", "7365", "7378", "7381", "8130", "8140", "8150", "8160", "8170", "8190", "8470"
]

export function isCommandePublique(entreprise, groupeActiviteTags, codeActiviteJuridique) {
  if (entreprise.siren.match(/^(1|2).*$/)) {
    return true;
  }

  if (groupeActiviteTags.some(tag => tagsCommandePublique.includes(tag))) {
    return true;
  }

  return codeActiviteJuridiqueCommandePublique.includes(codeActiviteJuridique);
}

export function canBeCommandePublique(entreprise, groupeActiviteTags, codeActiviteJuridique) {
  if (groupeActiviteTags.some(tag => tagsPotentiellementCommandePublique.includes(tag))) {
    return true;
  }

  return codeActiviteJuridiquePotentiellementCommandePublique.includes(codeActiviteJuridique);
}
